// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || ""
};

// Check if all required config values are present before initializing
// We need at least apiKey and projectId to initialize Firebase
const hasValidConfig = firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.apiKey !== "" && firebaseConfig.projectId !== "";

let app;
let analytics;
let auth;

if (hasValidConfig) {
  // Initialize Firebase
  app = initializeApp(firebaseConfig);
  analytics = getAnalytics(app);
  auth = getAuth(app);
} else {
  console.warn("Firebase not initialized: Missing configuration values. Only features that require Firebase will be unavailable.");
  
  // Create mock objects to prevent errors when Firebase is not configured
  app = null;
  analytics = null;
  auth = null;
}

export { auth, app, analytics };